export const TIMELINE_DISPLAY_NAME = 'timeline'
export const TIMELINE_ITEM_DISPLAY_NAME = 'TimelineItem'
export const TIMELINE_TITLE_DISPLAY_NAME = 'TimelineTitle'
export const TIMELINE_TEXT_DISPLAY_NAME = 'TimelineText'
export const TIMELINE_COMPONENT = 'TimelineComponent'

export const KINDS = {
  HORIZONTAL: 'Horizontal',
  VERTICAL: 'Vertical',
} as const

export const NODE_KINDS = {
  DOT: 'Dot',
  ELLIPSIS: 'Ellipsis',
} as const
